export const normalizeDate = (d: string | undefined): string | undefined => {
  if (!d) return undefined;
  const parsed = new Date(d);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed.toISOString().split("T")[0];
};

export const isAwsCatalog = (catalog: string | undefined): boolean => {
  const normalized = typeof catalog === "string" ? catalog.trim().toLowerCase() : "";
  return normalized === "aws" || normalized === "prd";
};
